'use client';

import Image, { type ImageProps } from 'next/image';
import { type ReactNode, useState } from 'react';

export function FallbackNextImage({
  onError,
  fallback,
  ...props
}: Omit<ImageProps, 'src'> & { src: string | null; fallback: ReactNode }) {
  const [imageError, setImageError] = useState(false);
  const src = props.src;

  return imageError || !src ? (
    fallback
  ) : (
    <Image
      onError={(e) => {
        setImageError(true);
        onError?.(e);
      }}
      {...props}
      src={src}
    />
  );
}
